import { sendEvent } from '../main/analytics/api';
import { ConnectModuleLinkData } from '../types';

import { throttle } from './utils';

const shortCircuitedAppKeys: string[] = ['jira-bitbucket-connector-plugin'];

export const shouldShortCircuit = (appKey: string): boolean => {
  const parsedAppKey = appKey ? appKey.split('.')[0] : '';
  return shortCircuitedAppKeys.includes(parsedAppKey);
};

function getLinkData(target: any, addon: any): ConnectModuleLinkData {
  return {
    moduleKey: target.getAttribute('data-module-key'),
    appKey: target.getAttribute('data-app-key'),
    linkKey: target.getAttribute('data-link-key'),
    text: target.textContent,
    href: target.href,
    principalId:
      target.getAttribute('data-principal-uuid') ||
      addon.options.productContext?.principalId ||
      // TODO: remove 'extension.options.moduleId' once productContext.moduleId
      // starts being used
      addon.options.principalId,
    extensionId: addon.extension_id,
  };
}

function getBoundingClientRect(element: HTMLElement) {
  const { top, right, bottom, left, width, height, x, y } =
    element.getBoundingClientRect();
  return { top, right, bottom, left, width, height, x, y };
}

function sendLinkerEvent(target: HTMLElement, type: string) {
  sendEvent('bitbucket.connect.linkers.href.event.click', {
    linker_key: target.getAttribute('data-link-key') || '',
    target_type: type,
  });
}

// eslint-disable-next-line import/no-default-export
export default (AP: any, isHost?: boolean) => {
  // @ts-ignore TODO: fix noImplicitAny error here
  let addon;
  if (isHost) {
    addon = { options: { isInlineDialog: true }, extension_id: '' };
  } else {
    try {
      addon = JSON.parse(window.name);
    } catch {
      throw new Error('AP failed to parse window name');
    }
  }
  if (
    typeof addon !== 'object' ||
    typeof addon.options !== 'object' ||
    addon.options === null
  ) {
    return;
  }
  window.addEventListener('keydown', (event: MouseEvent) =>
    AP.links.setConnectLinkMetaKey(event.ctrlKey || event.metaKey)
  );
  window.addEventListener('keyup', (event: MouseEvent) =>
    AP.links.setConnectLinkMetaKey(event.ctrlKey || event.metaKey)
  );
  if (!addon.options.isInlineDialog) {
    window.addEventListener(
      'scroll',
      throttle(() => AP.links.handleScrollEvent(), 300),
      true
    );
  }

  document.addEventListener('click', (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target || !target.classList) {
      return;
    }
    // @ts-ignore TODO: fix noImplicitAny error here
    const linkData = getLinkData(target, addon);
    const { appKey } = linkData;

    if (target.classList.contains('ap-connect-link')) {
      sendLinkerEvent(target, 'page');
      // Disable the default link behavior for connect apps that are in the shortCircuitedApps list
      if (shouldShortCircuit(appKey)) {
        return;
      }
      event.preventDefault();

      // @ts-ignore TODO: fix noImplicitAny error here
      AP.links.handleConnectLink(linkData);
    } else if (target.classList.contains('ap-connect-dialog')) {
      sendLinkerEvent(target, 'dialog');
      // Disable the default dialog behavior for connect apps that are in the shortCircuitedApps list
      if (shouldShortCircuit(appKey)) {
        return;
      }
      event.preventDefault();

      // @ts-ignore TODO: fix noImplicitAny error here
      AP.links.createDialog(linkData);
    } else if (target.classList.contains('ap-connect-inline-dialog')) {
      event.preventDefault();
      event.stopPropagation(); // This is needed to prevent inlineDialog closing after open as click gets triggered in parent frame.
      sendLinkerEvent(target, 'inlinedialog');
      AP.links.createInlineDialog({
        // @ts-ignore TODO: fix noImplicitAny error here
        ...linkData,
        position: getBoundingClientRect(target),
      });
    }
  });
};
